export default {
  state: {
    adminInfo: {
      isLogin: false,
      token: "",
      timestamp: "",
    }
  },
  mutations: {
    login(state, data) {
      state.adminInfo = {
        isLogin: true,
        token: data.token,
        deadLine: Date.parse(new Date()) + 7 * 24 * 60 * 60 * 1000
      }
      console.log(state.adminInfo)
      window.localStorage.setItem('adminInfo', JSON.stringify(state.adminInfo));
    }
  },

  getters: {
    token(state) {
      console.log("getters 中运行")
      let adminInfo = JSON.parse(window.localStorage.getItem('adminInfo'));
      console.log(adminInfo)
      if (adminInfo && Date.parse(new Date()) < adminInfo.deadLine) {
        return adminInfo.token;
      } else {
        return state.adminInfo.token;
      }
    }
  },

  actions: {
    login({commit}, data) {
      console.log("运行了")
      console.log(data)
      commit("login", data);
    },
  }
}
